import type { Extension } from "@medplum/fhirtypes";
import { ACT_CODE_SYSTEM } from "@repo/fhir-systems";
import { ENCOUNTER_CLASS_URL } from "./constants";

export {
  ACTIVITY_DEFINITION_IDS_URL,
  CARE_PLAN_GOALS_URL,
  ENCOUNTER_CLASS_URL,
  PROTOCOL_SCHEDULING_URL,
} from "./constants";

/** Build encounter-class extension (valueCoding). */
export function buildEncounterClassExtension(code: string, display: string): Extension {
  return {
    url: ENCOUNTER_CLASS_URL,
    valueCoding: {
      system: ACT_CODE_SYSTEM,
      code,
      display,
    },
  };
}

/** Parse encounter-class extension from a resource's extensions. Returns null if not found. */
export function parseEncounterClassExtension(
  extensions: Extension[] | undefined,
): { code: string; display: string } | null {
  const ext = extensions?.find((e) => e.url === ENCOUNTER_CLASS_URL);
  if (!ext?.valueCoding?.code) return null;
  return { code: ext.valueCoding.code, display: ext.valueCoding.display ?? ext.valueCoding.code };
}
